import { ProductTypeList } from '@/constants/supply';
import codes from 'i18n-iso-countries/codes.json';

export const nationList = codes.map(([code2, code3]) => {
  return { label: code3, value: code3 };
});

type IProductType = {
  value: any;
  label: string;
};

export const supplyList = ({
  productTypes,
  hospitalId,
}: {
  productTypes: any[];
  hospitalId: number;
}) => {
  let filteredList: IProductType[] = [];

  if (productTypes.length === 0) {
    filteredList = ProductTypeList.map((product) => {
      return {
        value: product.key,
        label: product.value,
      };
    });
  } else {
    productTypes.forEach((productType: string) => {
      const result = ProductTypeList.find(
        (product) => String(product.key) === String(productType),
      );
      if (result) {
        filteredList = [
          ...filteredList,
          { value: result.key, label: result.value },
        ];
      }
    });
  }

  if (
    hospitalId === 138 ||
    hospitalId === 1 ||
    hospitalId === 126 ||
    hospitalId === 156
  ) {
    const result = ProductTypeList[14];
    filteredList = [
      { value: result.key, label: result.value },
      ...filteredList.filter((item) => item.value !== 14),
    ];
  }

  return filteredList;
};
